var render = function () {
  var _vm$novelDetail, _vm$novelDetail2, _vm$novelDetail3, _vm$novelDetail4, _vm$novelDetail5, _vm$novelDetail6, _vm$novelDetail7, _vm$novelDetail7$plat, _vm$novelDetail8, _vm$novelDetail9;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container sub_wrap",
    attrs: {
      "id": "container"
    }
  }, [_c('article', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [_c('Breadcrumb'), _c('WPageWrapper', {
    attrs: {
      "first-fetch-data-callback": _vm.fetchData
    }
  }, [_c('div', {
    staticClass: "sub_section_wrap book_common_particulars"
  }, [_c('section', {
    staticClass: "page_section"
  }, [_c('div', {
    staticClass: "page_section_inner"
  }, [_c('div', {
    staticClass: "book_particulars_wrap"
  }, [_c('div', {
    staticClass: "book_info_top"
  }, [_c('div', {
    staticClass: "book_cover book_type4"
  }, [_c('div', {
    staticClass: "cover_img type2"
  }, [_c('img', {
    attrs: {
      "src": (_vm$novelDetail = _vm.novelDetail) === null || _vm$novelDetail === void 0 ? void 0 : _vm$novelDetail.coverImagePath,
      "alt": (_vm$novelDetail2 = _vm.novelDetail) === null || _vm$novelDetail2 === void 0 ? void 0 : _vm$novelDetail2.title
    }
  })])]), _c('div', {
    staticClass: "book_info_details"
  }, [_c('BookInfoTitle', {
    attrs: {
      "title": (_vm$novelDetail3 = _vm.novelDetail) === null || _vm$novelDetail3 === void 0 ? void 0 : _vm$novelDetail3.title,
      "book-seq": (_vm$novelDetail4 = _vm.novelDetail) === null || _vm$novelDetail4 === void 0 ? void 0 : _vm$novelDetail4.seq,
      "share-type": _vm.SHARE_TYPE.NOVEL
    }
  }), _c('div', {
    staticClass: "book_info_publishing"
  }, [_c('ul', {
    staticClass: "book_publishing"
  }, [_c('BookPublishingItem', {
    attrs: {
      "title": "저자"
    }
  }, [_c('BookAuthor', {
    attrs: {
      "authors": (_vm$novelDetail5 = _vm.novelDetail) === null || _vm$novelDetail5 === void 0 ? void 0 : _vm$novelDetail5.authors,
      "author-type": "NovelAuthorType"
    }
  })], 1), _vm.novelCategoryTyep ? _c('BookPublishingItem', {
    attrs: {
      "title": "분야"
    }
  }, [_vm._v(" " + _vm._s(_vm.novelCategoryTyep) + " ")]) : _vm._e(), _vm.ageRatingText ? _c('BookPublishingItem', {
    attrs: {
      "title": "연령등급"
    }
  }, [_vm._v(" " + _vm._s(_vm.ageRatingText) + " ")]) : _vm._e(), (_vm$novelDetail6 = _vm.novelDetail) !== null && _vm$novelDetail6 !== void 0 && _vm$novelDetail6.publicationDate ? _c('BookPublishingItem', {
    attrs: {
      "title": "출시일"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("date")(_vm.novelDetail.publicationDate)) + " ")]) : _vm._e(), ((_vm$novelDetail7 = _vm.novelDetail) === null || _vm$novelDetail7 === void 0 ? void 0 : (_vm$novelDetail7$plat = _vm$novelDetail7.platforms) === null || _vm$novelDetail7$plat === void 0 ? void 0 : _vm$novelDetail7$plat.length) > 0 ? _c('BookPublishingItem', {
    attrs: {
      "title": "플랫폼"
    }
  }, [_c('BookStoreTagList', {
    attrs: {
      "list": (_vm$novelDetail8 = _vm.novelDetail) === null || _vm$novelDetail8 === void 0 ? void 0 : _vm$novelDetail8.platforms
    }
  })], 1) : _vm._e()], 1)])], 1)]), _c('div', {
    staticClass: "page_title_wrap type2"
  }, [_c('h4', {
    staticClass: "page_title_text"
  }, [_vm._v("작품 소개")])]), _c('div', {
    staticClass: "book_info_summary"
  }, [_c('div', {
    staticClass: "book_info_article"
  }, [_c('LineBreakElement', {
    staticClass: "summary_body",
    attrs: {
      "tag-name": "div",
      "contents": (_vm$novelDetail9 = _vm.novelDetail) === null || _vm$novelDetail9 === void 0 ? void 0 : _vm$novelDetail9.introduction
    }
  })], 1)])])])])])])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }